<template>
  <div id="app">
  <Home></Home>
  </div>
</template>

<script>
import Home from "./components/Home.vue";
import store from "./store";
import router from "./router";

export default {
  name: "app",
  store,
  router,
  components: {
    Home
  }
};
</script>



<style lang="css">
@import "~bootstrap/dist/css/bootstrap.css";
@import "~bootstrap-vue/dist/bootstrap-vue.css";
@import "~font-awesome/css/font-awesome.css";
@import "~highcharts/css/highcharts.css";
</style>

<style>
html {
  font-size: 14px;
}
</style>
